import EventEmitter3 from 'eventemitter3';

export class Notification<T> {
  private emitter: EventEmitter3;

  constructor() {
    this.emitter = new EventEmitter3();
  }

  emit<K extends keyof T>(eventType: K, params: T[K]): void {
    this.emitter.emit(eventType as string, params);
  }

  on<K extends keyof T>(eventType: K, callback: (params: T[K]) => void): () => void {
    this.emitter.on(eventType as string, callback);
    return () => this.emitter.off(eventType as string, callback);
  }
}
